/* Full-screen placeholder while the session loads. */
import { useTranslation } from 'react-i18next'
import { LogoMark } from './Logo'

export function SplashScreen() {
  const { t } = useTranslation('common')
  return (
    <div
      className="grid min-h-dvh place-items-center bg-app-canvas"
      role="status"
      aria-label={t('ui.loading')}
    >
      <div className="flex flex-col items-center gap-5">
        <LogoMark className="h-10 w-auto animate-pulse" />
        <span className="h-1 w-24 overflow-hidden rounded-full bg-control-strong">
          <span className="block h-full w-1/2 skeleton rounded-full" />
        </span>
      </div>
    </div>
  )
}
